import {
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
  get_sessionNotFound2vlo9fobx2iqb as get_sessionNotFound,
} from './sdk/UserSession.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { PersistentProperty2s7ex88zm8bn9 as PersistentProperty } from '../../../kiteui-library/com/lightningkite/kiteui/reactive/PersistentProperty.mjs';
import { UUIDSerializer_getInstance2ms0oa88en0c as UUIDSerializer_getInstance } from '../../../lightning-server-shared/com/lightningkite/serialization/Serializers.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_selectedContractor() {
  _init_properties_selectedContractor_kt__wjrhv4();
  return selectedContractor;
}
var selectedContractor;
function get_currentContractor() {
  _init_properties_selectedContractor_kt__wjrhv4();
  return currentContractor;
}
var currentContractor;
function get_contractorStatus() {
  _init_properties_selectedContractor_kt__wjrhv4();
  return contractorStatus;
}
var contractorStatus;
function get_loggedInAsContractor() {
  _init_properties_selectedContractor_kt__wjrhv4();
  return loggedInAsContractor;
}
var loggedInAsContractor;
function get_notNullContractor() {
  _init_properties_selectedContractor_kt__wjrhv4();
  return notNullContractor;
}
var notNullContractor;
function currentContractor$lambda($this$remember) {
  _init_properties_selectedContractor_kt__wjrhv4();
  var tmp0_elvis_lhs = $this$remember.baj(get_rawSession());
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var session = tmp;
  var tmp1_elvis_lhs = $this$remember.baj(get_selectedContractor());
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var selected = tmp_0;
  return $this$remember.baj(session.jfv_1.eeo(selected));
}
function contractorStatus$lambda(it) {
  _init_properties_selectedContractor_kt__wjrhv4();
  return it == null ? null : it.t5j_1;
}
function loggedInAsContractor$lambda($this$remember) {
  _init_properties_selectedContractor_kt__wjrhv4();
  return !($this$remember.baj(get_selectedContractor()) == null);
}
function notNullContractor$lambda($this$remember) {
  _init_properties_selectedContractor_kt__wjrhv4();
  var tmp0_elvis_lhs = $this$remember.baj(get_selectedContractor());
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.run' call
    get_sessionNotFound().oaq();
    throw CancellationException().ld('Contractor not found');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
var properties_initialized_selectedContractor_kt_jcyt02;
function _init_properties_selectedContractor_kt__wjrhv4() {
  if (!properties_initialized_selectedContractor_kt_jcyt02) {
    properties_initialized_selectedContractor_kt_jcyt02 = true;
    selectedContractor = PersistentProperty().od8('SelectedContractor', null, get_nullable(UUIDSerializer_getInstance()));
    currentContractor = remember(VOID, VOID, VOID, currentContractor$lambda);
    var tmp = get_currentContractor();
    contractorStatus = lens(tmp, contractorStatus$lambda);
    loggedInAsContractor = remember(VOID, VOID, VOID, loggedInAsContractor$lambda);
    notNullContractor = remember(VOID, VOID, VOID, notNullContractor$lambda);
  }
}
//region block: exports
export {
  get_contractorStatus as get_contractorStatus37lp78am5imju,
  get_currentContractor as get_currentContractor2yiwyln4wfsro,
  get_loggedInAsContractor as get_loggedInAsContractorugpccxnrffn6,
  get_notNullContractor as get_notNullContractorsjk9enub7uol,
  get_selectedContractor as get_selectedContractor2m4vxuqdzv6k3,
};
//endregion

//# sourceMappingURL=selectedContractor.mjs.map
